<template>
  <div>
    <half-circle-spinner
      slot="loading"
      :animation-duration="1500"
      :size="50"
      color="#94c120"
      v-show="loadingArticle"
      class="my-5 mx-auto"
    />
    <div v-if="!loadingArticle">
      <button class="btn btn-primary btn-sm rounded" @click="$emit('go-back')">
        <div class="btn-with-icon-content">
          <i class="fa fa-arrow-left"></i>
          Back
        </div>
      </button>
      <div class="va-row justify--center">
        <div class="flex md6 xs12">
          <div v-html="articleHTML"></div>
        </div>
      </div>
      <button class="btn btn-primary btn-sm rounded" @click="$emit('go-back')">
        <div class="btn-with-icon-content">
          <i class="fa fa-arrow-left"></i>
          Back
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'

export default {
  name: 'ViewTopic',
  props: ['articleHTML', 'loadingArticle'],
  components: {
    HalfCircleSpinner
  }
}
</script>

<style></style>
